import { Button, Card, CircularProgress, Grid, TextField } from '@mui/material';
import { postSaveObjectApi, putUpdateObjectApi } from 'api/general';
import { SUGGESTION } from 'app/utils/constants/customConstant';
import { baseFontSize, dshCardHeight } from 'config';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import DshBoxTitle from '../Box/DshBoxTitle';

function AddUpdateSuggestionCard({ addAfterTable, updateAfterTable, handleDelete, setSuggestionInputStatus, suggestionOfTheUser }) {

    const { authUser } = useSelector(state => state.auth);
    const [loading, setLoading] = useState(false);
    const [buttonText, setButtonText] = useState("Kaydet");
    const currentMeeting = useSelector((state) => state.meeting.currentMeeting);

    const [isDeleteButtonVisible, setIsDeleteButtonVisible] = useState(false);

    const emptySuggestion = {
        userId: authUser.id,
        meetingId: currentMeeting.id,
        info: '',
        pdate: new Date()
    };
    const [suggestion, setSuggestion] = useState(suggestionOfTheUser === undefined ? emptySuggestion : suggestionOfTheUser);

    useEffect(() => {

        const getAPI = async () => {
            setLoading(true);
            try {

                if (suggestion.id) {
                    await buttonTextChange(1)
                }

            } catch (error) {
                console.error('Hata:', error);
            } finally {
                setLoading(false);
            }

        };
        getAPI();

    }, []);



    const buttonTextChange = async (type) => {
        if (type === 1) { // guncelleme
            setButtonText("Güncelle")
            setIsDeleteButtonVisible(true);

        } else if (type === 2) { // ekle
            setButtonText("Kaydet")
            setIsDeleteButtonVisible(false);
        }

    };



    const handleSave = async () => {


        // En az 3 karakter kontrolü
        if (!suggestion.info || suggestion.info.trim().length < 3) {
            Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'Görüşünüz veya öneriniz boş kaydedilemez.',
                showConfirmButton: false,
                timer: 2000
            });
            return;
        }


        if (suggestion.id) { // guncelleme
            try {

                let suggestionWithoutUser = Object.assign({}, suggestion);
                delete suggestionWithoutUser.user;
                suggestionWithoutUser.pdate = new Date();
                suggestion.pdate = new Date();
                const result = await putUpdateObjectApi(SUGGESTION, suggestionWithoutUser);
                if (result.status) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Öneriniz güncellendi.',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    updateAfterTable && updateAfterTable({ ...suggestion })

                }

            } catch (error) {
                console.error('Hata:', error);
            }
        } else { // ekleme
            try {

                const result = await postSaveObjectApi(SUGGESTION, suggestion);
                if (result.status) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Öneriniz kaydedildi.',
                        showConfirmButton: false,
                        timer: 1500

                    });
                    suggestion.id = result.data.insertId;
                    setButtonText("Güncelle")
                    setIsDeleteButtonVisible(true)
                    addAfterTable({ id: result.data.insertId, ...suggestion }); // sor????
                }

            } catch (error) {
                console.error('Hata:', error);
            }


        }

    };


    const handleDeleteItem = async (suggestion) => {
        const result = await handleDelete(suggestion)
        if (result.status) {
            setSuggestion(emptySuggestion)
            setSuggestionInputStatus(false)

            await buttonTextChange(2)
        }
    };


    const handleChange = name => (e) => {

        setSuggestion({
            ...suggestion,
            [name]: e.target.value
        })
    }




    return (
        <div style={{ fontSize: baseFontSize }}>
            {loading ? (
                <CircularProgress />
            ) : (
                <Card sx={{
                    m: 0,
                    p: '10px',
                    marginBottom: 0,
                    minHeight: `${dshCardHeight}`,
                    // height: `${dshPreviousCardHeight}`,
                }}>
                    <DshBoxTitle color="error" title={"GÜNDEM DIŞI GÖRÜŞ VE ÖNERİ"} />


                    <Grid container>
                        <Grid item xs={12} md={12} lg={12} sx={{ padding: 1, fontSize: baseFontSize }} >
                            <span>Sayın üyelerimiz, Başkanlığımıza iletmek istediğiniz görüş ve önerilerinizi bu maddenin değerlendirme kısmına yazabilirsiniz.</span>
                        </Grid>

                        <Grid
                            container
                            marginY={2}
                            marginX={0}
                            spacing={1}
                            rowSpacing={1}
                        >
                            <Grid item xs={11} md={11} lg={11}>
                                <TextField
                                    variant="outlined"
                                    label="Önerinizi yazınız..."
                                    multiline
                                    fullWidth
                                    rows={6}
                                    value={suggestion.info}
                                    onChange={handleChange("info")}
                                    InputProps={{
                                        style: { fontSize: baseFontSize },
                                    }}
                                    InputLabelProps={{
                                        style: { fontSize: baseFontSize },
                                    }}
                                />

                            </Grid>

                            <Grid item xs={6} md={6} lg={1}>
                                <Button
                                    variant="contained"
                                    size='small'
                                    color="success"
                                    onClick={handleSave}
                                    style={{
                                        maxWidth: "100%",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                                    {buttonText}
                                </Button>
                                {isDeleteButtonVisible && (
                                    <Button
                                        variant="contained"
                                        color="error"
                                        size='small'
                                        onClick={() => handleDeleteItem(suggestion)}
                                        style={{
                                            marginTop: "5px",
                                            maxWidth: "100%",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        Sil
                                    </Button>
                                )}
                            </Grid>
                        </Grid>


                    </Grid>
                </Card>
            )}
        </div>
    );
}
export default AddUpdateSuggestionCard;


